"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { IconBuildingBank, IconCreditCard, IconReceipt2 } from "@xefi/x-react/icons";
import { useTranslation } from "react-i18next";
import { usePaymentsKpi } from "@/hooks/usePaymentsKpi";
import { usePaymentsDateRange, usePaymentsDomaIds, usePaymentsSubsidiaryId } from "@/store/usePaymentsFiltersStore";
import { formatAmount } from "@/utils/utils";
import { toScopeParams } from "../common/paymentsQuery";
import KpiCard from "./KpiCard";
const PLACEHOLDER_AMOUNT = "—";
export default function PaymentsKpi() {
  const $ = _c(54);
  const {
    t
  } = useTranslation();
  const subsidiaryId = usePaymentsSubsidiaryId();
  const domaIds = usePaymentsDomaIds();
  const dateRange = usePaymentsDateRange();
  let t0;
  if ($[0] !== dateRange || $[1] !== domaIds || $[2] !== subsidiaryId) {
    t0 = toScopeParams({
      subsidiaryId,
      domaIds,
      dateRange
    });
    $[0] = dateRange;
    $[1] = domaIds;
    $[2] = subsidiaryId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const params = t0;
  const {
    data,
    isLoading,
    isError
  } = usePaymentsKpi(params);
  let t1;
  if ($[4] !== isError || $[5] !== isLoading) {
    t1 = amount => isLoading || isError || amount === undefined ? PLACEHOLDER_AMOUNT : formatAmount(amount);
    $[4] = isError;
    $[5] = isLoading;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const formatCardAmount = t1;
  let t2;
  if ($[7] !== isError || $[8] !== isLoading || $[9] !== t) {
    t2 = count => isLoading || isError || count === undefined ? "" : t("paymentsReceived.kpi.count", {
      count
    });
    $[7] = isError;
    $[8] = isLoading;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const formatCardCount = t2;
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconBuildingBank className="size-7" />;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t) {
    t4 = t("paymentsReceived.kpi.nationalTransfers");
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = data?.national_transfers.amount;
  let t6;
  if ($[14] !== formatCardAmount || $[15] !== t5) {
    t6 = formatCardAmount(t5);
    $[14] = formatCardAmount;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = data?.national_transfers.count;
  let t8;
  if ($[17] !== formatCardCount || $[18] !== t7) {
    t8 = formatCardCount(t7);
    $[17] = formatCardCount;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t6 || $[22] !== t8) {
    t9 = <KpiCard icon={t3} label={t4} amount={t6} count={t8} />;
    $[20] = t4;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconCreditCard className="size-7" />;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("paymentsReceived.kpi.telecollections");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = data?.telecollections.amount;
  let t13;
  if ($[27] !== formatCardAmount || $[28] !== t12) {
    t13 = formatCardAmount(t12);
    $[27] = formatCardAmount;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = data?.telecollections.count;
  let t15;
  if ($[30] !== formatCardCount || $[31] !== t14) {
    t15 = formatCardCount(t14);
    $[30] = formatCardCount;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t11 || $[34] !== t13 || $[35] !== t15) {
    t16 = <KpiCard icon={t10} label={t11} amount={t13} count={t15} />;
    $[33] = t11;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IconReceipt2 className="size-7" />;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("paymentsReceived.kpi.missingCardPayments");
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const t19 = data?.missing_card_payments.amount;
  let t20;
  if ($[40] !== formatCardAmount || $[41] !== t19) {
    t20 = formatCardAmount(t19);
    $[40] = formatCardAmount;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = data?.missing_card_payments.count;
  let t22;
  if ($[43] !== formatCardCount || $[44] !== t21) {
    t22 = formatCardCount(t21);
    $[43] = formatCardCount;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t18 || $[47] !== t20 || $[48] !== t22) {
    t23 = <KpiCard icon={t17} label={t18} amount={t20} count={t22} />;
    $[46] = t18;
    $[47] = t20;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t16 || $[51] !== t23 || $[52] !== t9) {
    t24 = <div className="mb-6 flex w-full items-center divide-x divide-gray-200 rounded-xl border border-border bg-content1 dark:divide-[#3a3a3a] dark:bg-content1-100">{t9}{t16}{t23}</div>;
    $[50] = t16;
    $[51] = t23;
    $[52] = t9;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  return t24;
}